<template>
  <div class="modal" v-if="seen">
    <div class="permanent">
      <span>Deleting <strong>files</strong> permanently</span>
      <br />
      <span><img src="@/assets/30.gif" /></span>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      seen: false,
      loader: false,
      error: false,
      id: null,
      found: false
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOTAL_USED_SPACE',
      'EMPTY_FILE_ACTION',
      'SET_FILE_ACTION',
      'EMPTY_FILES_INDEX',
      'SET_SELECT_ALL'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    load() {
      this.seen = true

      let that = this

      let data = {
        token: cookies.getCookie('token'),
        files: this.$store.getters.GET_FILE_ACTION,
        delete_type: false
      };

      this.$socket.emit('group-delete-permanently', data, function (data) {
        if (data.message === 'completed') {
          that.seen = false

          let indexes = Object.values(that.$store.getters.GET_FILES_INDEX)

          indexes.forEach(index => {
            that.$store.getters.DIRECTORY_CHILDREN.splice(index, 1)
          })

          that.$store.getters.DIRECTORY_CHILDREN.map(file => {
            file.is_checked = false
          })

          that.EMPTY_FILE_ACTION()
          that.EMPTY_FILES_INDEX()
          that.SET_FILE_ACTION('')
          that.SET_SELECT_ALL(false)
        }

        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>
